import React from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({
  currentPageNo,
  onPageChange,
  totalPages,
  pageRangeDisplayed,
  isMobile,
}) => {
  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel=">"
      onPageChange={onPageChange}
      pageRangeDisplayed={isMobile ? 2 : pageRangeDisplayed}
      marginPagesDisplayed={isMobile ? 1 : 2}
      pageCount={totalPages}
      previousLabel="<"
      forcePage={currentPageNo}
      renderOnZeroPageCount={null}
      pageClassName="page-item"
      pageLinkClassName="page-link"
      previousClassName="page-item"
      previousLinkClassName="page-link"
      nextClassName="page-item"
      nextLinkClassName="page-link"
      breakClassName="page-item"
      breakLinkClassName="page-link"
      containerClassName="pagination flex-wrap"
      activeClassName="active"
    />
  );
};

export default Pagination;
